import { modifier } from 'ember-modifier';
import { next } from '@ember/runloop';
export default modifier((element, [cb, ec]) => {
  const callback = cb;
  const exceptionClass = ec;
  function handleClick(event) {
    // If the main element was clicked, don't do anything
    if (element.contains(event.target) || element === event.target) {
      return;
    }

    // If no exceptionClass was provided, call the callback
    if (!exceptionClass) {
      callback();
      return;
    }

    // If the element that was clicked is an exception (or within the exception)
    // to the rule as identified by a class name, don't call the callback
    const targetIsWithinException = event.composedPath().find(parent => {
      return parent.classList?.contains(exceptionClass);
    });
    if (exceptionClass && !targetIsWithinException) {
      callback();
    }
  }

  // Wait until the next render to attach the handler
  next(() => {
    document.addEventListener('click', handleClick);
  });
  return () => {
    document.removeEventListener('click', handleClick);
  };
});